import { Page } from "@/models/page-models/Page";

export const TransactionListing: Page = {
  "path": "transaction-listing",
  "name": "Transaction Listing",
  "props": {
    "data": {
      "title": "Transaction Listing",
      "printable": "TRUE",
      "url": "transaction-listing",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "radioGroup",
                  "variable": "formData.type",
                  "label": "Type",
                  "disabled": "FALSE",
                  "items": "[{\"label\":\"All RM Receipts\",\"value\":\"rm-receipts\"},{\"label\":\"All Issues\",\"value\":\"issues\"},{\"label\":\"All Receipts\",\"value\":\"all-receipts\"},{\"label\":\"All\",\"value\":\"all\"}]"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.startDate",
                  "label": "Start Date",
                  "disabled": "FALSE"
                },
                {
                  "type": "datepicker",
                  "variable": "formData.endDate",
                  "label": "End Date",
                  "disabled": "FALSE"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Load Transaction Listing",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "name": "getTransactionListing"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "table",
                  "label": "Transaction Listing",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.transactionListings}}",
                  "items": "fetchedData.transactionListings.data",
                  "headers": [
                    {
                      "value": "_id",
                      "text": "Transaction Ref#"
                    },
                    {
                      "value": "rmCode",
                      "text": "RM Code"
                    },
                    {
                      "value": "createdAt",
                      "text": "Date",
                      "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                    },
                    {
                      "value": "type",
                      "text": "Type"
                    },
                    {
                      "value": "receivedFrom",
                      "text": "Received From"
                    },
                    {
                      "value": "quantity",
                      "text": "Quantity"
                    },
                    {
                      "value": "unitPrice",
                      "text": "Unit Price"
                    },
                    {
                      "value": "poId",
                      "text": "PO#"
                    },
                    {
                      "value": "supplierId",
                      "text": "Supplier #"
                    }
                  ],
                  "tableType": "static"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ]
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getTransactionListing"
      }
    ],
    "functions": [
      {
        "name": "getTransactionListing",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v2/reports/transaction-listing?type={{formData.type}}&endDate={{formData.endDate}}&startDate={{formData.startDate}}",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.transactionListings"
      }
    ]
  },
  "forRole": "ACCOUNTING_MANAGER,ACCOUNTING_EXECUTIVE",
  "visible": false
}